import { StockTankFormState } from '@navstation-portal/reporting/data-model/vessel-report';
import { Tank } from '@navstation-portal/vessels/data-model/vessel';
import { initStateField } from '../../../offshore-report-utils/store.utility';

export function sortAndEnrichTanksByVesselSpec(
  rows: StockTankFormState[],
  vesselSpecTanks: Tank[]
): StockTankFormState[] {
  // originalIndex maps tank id → its position in the original rows array.
  // This is critical: form controls use this index to dispatch updates back into
  // the store's tankRows array, so it MUST match the original store position.
  const originalIndexMap = new Map(rows.map((t, i) => [t.id.value?.toString() ?? '', i]));

  if (!rows.length || !vesselSpecTanks.length) {
    return rows.map((t, i) => ({ ...t, index: initStateField<number>(i) }));
  }

  const tankMap = new Map(rows.map((t) => [t.id.value?.toString() ?? '', t]));

  const usedIds = new Set<string>();

  const sorted = vesselSpecTanks
    .map((spec) => {
      const id = spec.tank_id.$oid;
      const tank = tankMap.get(id);
      if (!tank) return;

      usedIds.add(id);

      return {
        ...tank,
        index: initStateField<number>(originalIndexMap.get(id) ?? 0),
        tankName: initStateField(spec.name),
        tankCapacity: initStateField(spec.volume_ratings?.[0]?.value),
      };
    })
    .filter((t): t is StockTankFormState => !!t);

  const extras = rows
    .filter((t) => {
      const id = t.id.value?.toString();
      return !id || !usedIds.has(id);
    })
    .map((t) => ({
      ...t,
      index: initStateField<number>(originalIndexMap.get(t.id.value?.toString() ?? '') ?? 0),
    }));

  return [...sorted, ...extras];
}
